import { Box, styled, Typography } from '@mui/material'
import type { FC, PropsWithChildren } from 'react'

import { COLORS, unit } from '@hcr/pwa/components'

type HistoryDividerProps = PropsWithChildren

export const HistoryDivider: FC<HistoryDividerProps> = ({ children }) => {
  return (
    <Container>
      <Typography variant='uppercaseS'>{children}</Typography>
    </Container>
  )
}

const Container = styled(Box)`
  background-color: ${COLORS.hiekka[500]};
  padding: ${unit(3.5)} ${unit(7)};
`
